import { ClipboardPlus, Home, Scroll, Settings, Video } from "lucide-react";

export const weightLossNavigationItems = [
  {
    title: "Home",
    url: "/dashboard/weight-loss",
    icon: <Home />,
    notifications: 1
  },
  {
    title: "Medicals",
    url: "/dashboard/weight-loss/medicals",
    matchUrls: ["/dashboard/weight-loss/medicals", "/dashboard/weight-loss/medicals/medications", "/dashboard/weight-loss/medicals/conditions"],
    icon: <ClipboardPlus />
  },
  {
    title: "Appointments",
    url: "/dashboard/weight-loss/appointments",
    matchUrls: ["/dashboard/weight-loss/appointments", "/dashboard/weight-loss/appointments/upcoming", "/dashboard/weight-loss/appointments/past"],
    icon: <Video />
  },
  {
    title: "Settings",
    url: "/dashboard/settings",
    matchUrls: [
      "/dashboard/settings/user-profile",
    ],
    icon: <Settings />
  },
  //   {
  //   title: "Support",
  //   url: "/dashboard/support",
  //   matchUrls: ["/dashboard/support"],
  //   icon: <HelpCircle />
  // }
];

export const urgentCareNavigationItems = [
  {
    title: "Home",
    url: "/dashboard/urgent-care/",
    icon: <Home />,
    notifications: 1
  },
  {
    title: "Encounters",
    url: "/dashboard/urgent-care/encounters",
    matchUrls: ["/dashboard/urgent-care/encounters"],
    icon:  <Scroll />
  },
  {
    title: "Appointments",
    url: "/dashboard/urgent-care/appointments",
    matchUrls: ["/dashboard/urgent-care/appointments"],
    icon: <Video />
  },
  {
    title: "Settings",
    url: "/dashboard/settings",
    matchUrls: [
      "/dashboard/settings/user-profile"
    ],
    icon: <Settings />
  },
];


export type NavigationItem = {
  title: string;
  url: string;
  matchUrls?: string[];
  icon?: React.ReactNode;
  notifications?: number;
};
